/** Legacy status tag colours (styles/custom_status.css + redistribution StatusColors). */
const LEGACY_STATUS_COLORS: Record<string, string> = {
  'changes requested': '#f57f26',
  submitted: '#F57E23',
  'county approved': '#6eaa2c',
  approved: '#058237',
  complete: '#6EAA2C',
  completed: '#6EAA2C',
  accepted: '#6EAA2C',
  incomplete: '#adadad',
  'not started': '#474747',
  denied: '#D0021B',
  'county denied': '#D0021B',
  declined: '#D0021B',
  overdue: '#D0021B',
  due: '#F57E23',
  current: '#6EAA2C',
  pending: '#F57E23',
};

export const legacyStatusColor = (status?: string | null) =>
  LEGACY_STATUS_COLORS[String(status || '').toLowerCase()] || '#adadad';

/**
 * The legacy solid status chip (palmetto-ui-components StatusComponent with
 * the rep-ui `custom_status.css` classes): white text on the status colour,
 * 3px 12px padding, 3px radius, 14px/500.
 */
const StatusTag = ({ status, fontSize = 14 }: { status?: string | null; fontSize?: number }) => {
  if (!status) return null;
  return (
    <span
      style={{
        display: 'inline-block',
        color: 'rgba(255, 255, 255, 0.87)',
        backgroundColor: legacyStatusColor(status),
        padding: '3px 12px',
        textAlign: 'center',
        borderRadius: 3,
        fontSize,
        lineHeight: 1.5,
        fontWeight: 500,
        whiteSpace: 'nowrap',
      }}>
      {status}
    </span>
  );
};

export default StatusTag;
